import React from 'react';
import logo from './Assets/APCOA_Parking_logo_web.png';
import Welcome from './app/welcome/Welcome'
import Voucher from './app/voucher/Voucher'
import Receipt from './app/receipt/Receipt'
import Confirm from './app/confirm/Confirm'
import axios from 'axios'
import LanguageSelector from './app/features/LanguageSelector';
import {
    Route,
    Routes,
    Navigate,useSearchParams,useParams
} from "react-router-dom";
import MessageBox from './app/features/MessageBox'
import {isUsableUid, rememberUid, recallUid} from './utils/uid';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

// Last resort, only when the tablet has never recorded a uid on this device.
// Anything else is recovered automatically by Recover below.
function InvalidLink() {
    return (
        <div className="w-full flex justify-center pt-10 px-5 text-center">
            <p className="font-bold text-xl">Fejl i link. Kontakt APCOA.</p>
        </div>
    );
}

// The tablets sit unattended in kiosk mode, each pinned to its own uid, so a
// dead route means someone has to physically visit it. Send it back to the uid
// this device last used instead.
function Recover() {
    const uid = recallUid();
    if (uid) {
        return (<Navigate to={`/${uid}`} replace/>)
    }
    return (<InvalidLink/>)
}

function RedirectTablet() {
    const [searchParams,setSearchParams] = useSearchParams();
    const uid = searchParams.get("uid");
    // searchParams.get returns null when ?uid= is absent, and `/${null}` would
    // send the tablet to the dead route "/null".
    if (!isUsableUid(uid)) {
        return (<Recover/>)
    }
    return (<Navigate to={`/${uid}`}/>)
}

// "/undefined" and "/null" are real path segments, so they match /:uid like any
// other value. Catch them here rather than letting the page load and fail.
function GuestSite() {
    const {uid} = useParams();

    // Remember every uid the tablet is legitimately opened with, so it can put
    // itself back here if it ever loses the value.
    React.useEffect(() => {
        rememberUid(uid);
    }, [uid]);

    if (!isUsableUid(uid)) {
        return (<Recover/>)
    }
    return (<Welcome/>)
}

function RedirectToBakken(){
    window.location.href = 'https://bakken.mobilparkering.dk/bakken';
}
function App() {
    // 'const routes = useRoutes([
    //     {path: '/tablet?uid=:uid', element: <RedirectTablet/>},
    //     {path: '/:uid', element: <Welcome/>},
    //    
    //     {path: '/voucher', element: <Voucher/>},
    //     {path: '/:uid/confirm', element: <Confirm/>},
    //     {path: '/:uid/receipt', element: <Receipt/>},
    //     {path: '/confirm', element: <Confirm/>},
    //     {path: '/receipt', element: <Receipt/>},
    // ]);'

    return (
        <div>

            <div className=" pb-10 pt-5 flex relative py-8" style={{backgroundColor: '#ffffff'}}>
                <div className="absolute w-full">
                    <div className="w-full flex justify-center">
                        <div className="py-2 w-50">
                            <img alt="Apcoa" src={logo}/>
                        </div>
                    </div>
                </div>
                <div className="ml-auto z-10">
                    <LanguageSelector/>
                </div>

            </div>

            <div>
                <div className="sticky">
                    <MessageBox/>
                </div>

                <Routes>
                    <Route path="/bakken" element={
                        <RedirectToBakken/>
                    }/>
                    <Route path="/tablet" element={
                        <RedirectTablet/>
                    }/>
                    <Route path="/:uid" element={
                        <GuestSite/>
                    }/>
                    <Route path="/voucherparkering" element={
                        <Voucher/>
                    }/>
                    <Route path="/:uid/confirm" element={
                        <Confirm/>
                    }/>
                    <Route path="/:uid/receipt" element={
                        <Receipt/>
                    }/>
                    <Route path="/receipt" element={
                        <Receipt/>
                    }/>
                    <Route path="/confirm" element={
                        <Confirm/>
                    }/>
                    <Route path="*" element={
                        <Recover/>
                    }/>
                </Routes>
            </div>
        </div>
    )

}

export default App;
